import React, { useContext } from "react";
import { Button, ButtonToolbar, Glyphicon } from "react-bootstrap";
import { Grid, RemoteGrid } from "../../Grid";
import { Panel, PanelHeader } from "../../Panel";
import { FileFilters } from "../../../constant";

import usePermission from "provider/PermissionProvider";
import { FIRMWARE_KEY } from "provider/PermissionProvider/permissions";
import { Tag } from "@gf-easy-8/grmnext-foundation";
import styled, { ThemeContext } from "styled-components";

export const TagContainer = styled.div`
  display: inline-block;
  & > div {
    margin-left: initial;
    margin-bottom: 2px;
    margin-right: 2px;
  }
`;

TagContainer.displayName = "TagContainer";

export function Firmwares({
  files,
  onUploadFirmware,
  onUpdateFirmware,
  onDeleteFirmware,
  onToggleActivityLogs,
  isLoading,
  onHandleTableChange,
  onHandleSearch,
  pagination,
}) {
  const theme = useContext(ThemeContext);
  const { permissionContext } = usePermission();
  const { hasAtLeastOneFullPermission } = permissionContext.permissions;
  const columns = [
    {
      dataField: "id",
      text: "Id",
      hidden: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "fileName",
      text: "File Name",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "unitFamilies",
      text: "Family",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
      formatter: (cell, row) => (
        <>
          {row.unitFamilies.map((family) => (
            <TagContainer>
              <Tag
                backgroundColor={theme.colours.appHeader.background}
                disabled
                text={family.unitFamilyName}
              />
            </TagContainer>
          ))}
        </>
      ),
    },
    {
      dataField: "fileTypeValue",
      text: "File Type",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "releaseNote",
      text: "Release Notes",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "newSWSAPNumber",
      text: "SW SAP Number and Version",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    }, 
    {
      dataField: "sha256",
      text: "Sha256",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "fileSize",
      text: "File Size",
      sort: true,
      style: { wordWrap: "break-word" },
      headerStyle: { wordWrap: "break-word" },
      title: (cell) => cell,
    },
    {
      dataField: "buttons",
      text: "",
      formatter: (cell, row) => (
        <ButtonToolbar>
          {row.isEditable ? (
            <Button
              bsStyle="primary"
              title="Edit Firmware"
              onClick={() => onUpdateFirmware(row)}
            >
              <Glyphicon glyph="pencil" />
            </Button>
          ) : (
            <Button
              bsStyle="primary"
              title="View Firmware"
              onClick={() => onUpdateFirmware(row)}
            >
              <Glyphicon glyph="eye-open" />
            </Button>
          )}
          <Button
            bsStyle="danger"
            title="Delete Firmware"
            onClick={() => onDeleteFirmware(row)}
            disabled={!row.isEditable}
          >
            <Glyphicon glyph="trash" />
          </Button>
        </ButtonToolbar>
      ),
    },
  ];

  return (
    <Panel>
      <PanelHeader>
        <ButtonToolbar>
          {hasAtLeastOneFullPermission(FIRMWARE_KEY) && (
            <Button bsSize="small" bsStyle="success" onClick={onUploadFirmware}>
              <Glyphicon glyph="cloud-upload" /> Upload Firmware
            </Button>
          )}
          <Button
            bsSize="small"
            bsStyle="primary"
            onClick={onToggleActivityLogs}
          >
            <Glyphicon glyph="tasks" /> View Activity Logs
          </Button>
        </ButtonToolbar>
      </PanelHeader>
      <div className="panel-body">
        <RemoteGrid
          filterFields={FileFilters}
          data={files}
          columns={columns}
          loading={isLoading}
          pagination={pagination}
          onSearch={onHandleSearch}
          onTableChange={onHandleTableChange}
        />
      </div>
    </Panel>
  );
}
